import AbsComponent from "../AbsComponent";

export default class AbilitiesPoint extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', _l10n={}){
        super(_name, _store, _actions, _router, _el, _l10n);
        this.addEvents();
    }

    compare(_d1, _d2){
        if (_d1>_d2) {
            return `<span class="icon morethan">▲</span>`;
        }
        if (_d1<_d2) {
            return `<span class="icon lessthan">▼</span>`;
        }
        if (_d1===_d2) {
            return `<span class="icon equal">-</span>`;
        }
    }

    setting(_d, _parent, _compareMode = false, _d2 = null){
        $(_parent).toggle(this.store.getState().isAllowed);
        if (!this.store.getState().isAllowed) {
            return;
        }
        
        if (!_d.data.point_ability) return false;
        
        _d = _d.data;
        let isCompare = !!_d2;

        let templ = $(`
    <div class="point-ability">
        <!-- 공격점수 -->
        <span class="point offense">
            ${isCompare? this.compare(_d.point_ability.attack_power_value, _d2.point_ability.attack_power_value): ``}
            ${_d.point_ability.attack_power_value}P
        </span>
        <!-- 방어점수 -->
        <span class="point defense">
            ${isCompare? this.compare(_d.point_ability.defense_point, _d2.point_ability.defense_point): ``}
            ${_d.point_ability.defense_point}P
        </span>
        <!-- 구분선 -->
        <span class="bar"></span>
        <!-- 위협 -->
        <span class="point picks-1 ${_d.point_ability.picks[0].point>0? ``: `disabed`}">
            ${isCompare? this.compare(_d.point_ability.picks[0].point, _d2.point_ability.picks[0].point): ``}
            ${_d.point_ability.picks[0].point}P
        </span>
        <!-- 재생 -->
        <span class="point picks-2 ${_d.point_ability.picks[1].point>0? ``: `disabed`}">
            ${isCompare? this.compare(_d.point_ability.picks[1].point, _d2.point_ability.picks[1].point): ``}
            ${_d.point_ability.picks[1].point}P
        </span>
        <!-- 이동속도 -->
        <span class="point picks-3 ${_d.point_ability.picks[2].point>0? ``: `disabed`}">
            ${isCompare? this.compare(_d.point_ability.picks[2].point, _d2.point_ability.picks[2].point): ``}
            ${_d.point_ability.picks[2].point}P
        </span>
        <!-- 홍문지기 -->
        <span class="point picks-4 ${_d.point_ability.picks[3].point>0? ``: `disabed`}">
            ${isCompare? this.compare(_d.point_ability.picks[3].point, _d2.point_ability.picks[3].point): ``}
            ${_d.point_ability.picks[3].point}P
        </span>
        <!-- 상태이상 -->
        <span class="point picks-5 ${_d.point_ability.picks[4].point>0? ``: `disabed`}">
            ${isCompare? this.compare(_d.point_ability.picks[4].point, _d2.point_ability.picks[4].point): ``}
            ${_d.point_ability.picks[4].point}P
        </span>
    </div>
`);

        $(_parent).empty().append(templ);
    }

    addEvents(){
    }


} // end of class